import React from 'react'
import styles from './Card.module.scss'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import { Icon, CheckCircleIcon } from 'components/shared/Icon/Icon'
import ClockIcon from 'assets/icons/grey-clock.svg'

export const Card = ({
  image,
  name,
  description,
  onClick,
  completed,
  buttonLabel,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.title}>
        <img src={image} /> {name}{' '}
        {completed && (
          <Icon size={14} icon={CheckCircleIcon} className={styles.icon} />
        )}
      </div>
      <div className={styles.description}>{description}</div>
      <div className={styles.time}>
        <img src={ClockIcon} />
        <span>~20 min</span>
      </div>
      <div className={styles.button}>
        <BoldButton
          label={buttonLabel}
          isPrimary={!completed}
          width="156px"
          onClick={onClick}
        />
      </div>
    </div>
  )
}
